module.exports = __webpack_public_path__ + "img/loader.22eeb51b.png";